/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment } from 'react'
import { Modal } from 'antd-mobile'
import { isMobile } from 'react-device-detect'
import BettingHistoryTab from '@views/BettingHistory/BettingHistoryTab'
// css
import { ModalBg, PageBgStyle } from '@styles/base.style'
import { Button, CloseBtn } from '@styles/button.style'
// icon
import useRootStore from '@store/useRootStore'
import { useOnMount } from '@utils/reactExt'
import BettingHistoryBg from '@assets/images/bg/betting-history-bg.png'
import { BettingListSelectorWrap, ModalBottomBtnStyle } from './index.style'


const BettingListSelectorPopup: React.FC = () => {
  const { pickStore, globalStore, bettingHistoryStore } = useRootStore()
  const { visibleBettingListPopup } = globalStore

  // full-modal className 을 붙이기 위해.
  const isFullModal = true

  const fetchPublishItem = async () => {
    await pickStore.fetchPublishPick({})
  }

  useOnMount(fetchPublishItem)

  const onClickCloseButtonHandler = () => {
    bettingHistoryStore.setSelectedBettingHistoryByBettingRecordTrack(
      null, bettingHistoryStore.bettingHistoryInitProps.fromViewType,
    )
    globalStore.setVisibleBettingListPopup(false)
  }

  const onClickBetHistoryItemUploadHandler = () => {
    globalStore.setVisibleBettingListPopup(false)
  }

  return (
    <Fragment>
      <Modal
        popup
        maskClosable={false}
        visible={visibleBettingListPopup}
        animated={isMobile}
        animationType="slide-up"
        onClose={onClickCloseButtonHandler}
        title={
          <Fragment>
            <h1 className="title">베팅 내역</h1>
            <Button onClick={onClickCloseButtonHandler} className="close-btn" css={CloseBtn}>
              <span className="close-txt">닫기</span>
            </Button>
          </Fragment>
        }
        className="full-modal betting-list-popup"
      >

        <BettingListSelectorWrap>
          <div css={PageBgStyle} className="betting-history-bg">
            <img src={BettingHistoryBg} alt="야구선수 배경"/>
          </div>
          <BettingHistoryTab isFullModal={isFullModal}/>
        </BettingListSelectorWrap>

        <Button primary css={ModalBottomBtnStyle} onClick={onClickBetHistoryItemUploadHandler}>확인</Button>

        {!isMobile && <ModalBg onClick={onClickCloseButtonHandler}/>}
      </Modal>
    </Fragment>
  )
}

export default observer(BettingListSelectorPopup)
